//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import ProductTable from "@/pages/Hierarchies/Classification/components/ProductTable.vue";
import ProductTab from "@/pages/Hierarchies/Classification/components/ProductTab.vue";
import StoresTab from "@/pages/Hierarchies/Classification/components/StoresTab.vue";
import StoresTable from "@/pages/Hierarchies/Classification/components/StoresTable.vue";
import GeographyTable from "@/pages/Hierarchies/Classification/components/GeographyTable.vue";
import GeographyTab from "@/pages/Hierarchies/Classification/components/GeographyTab.vue";
import SalesForceTab from "@/pages/Hierarchies/Classification/components/SalesForceTab.vue";
import SalesForceTable from "@/pages/Hierarchies/Classification/components/SalesForceTable.vue";
import NielsenTable from "@/pages/Hierarchies/Classification/components/NielsenTable.vue";
import NielsenTab from "@/pages/Hierarchies/Classification/components/NielsenTab.vue";

export default {
  name: "Hierarchies",
  components: {
    ProductTable,
    ProductTab,
    StoresTab,
    StoresTable,
    SalesForceTable,
    SalesForceTab,
    GeographyTable,
    GeographyTab,
    NielsenTable,
    NielsenTab,
  },
  mounted: function () {
    BackendServices.getProductHierarchyLevels().then(
      (result) => (this.tableData = result.data)
    );
  },
  data: () => ({
    createMode: false,
    productForm: true,
    storesForm: true,
    geographyForm: true,
    salesForceForm: true,
    filterState: null,
    product: {
      level_id: null,
      parent_id: null,
      name: null,
    },
    stores: {
      level_id: null,
      parent_id: null,
      name: null,
    },
    salesForce: {
      level_id: null,
      parent_id: null,
      name: null,
    },
    geography: {
      level_id: null,
      parent_id: null,
      name: null,
    },
    nielsen: {
      id: null,
      name: null,
    },
    tableData: [],
    tableTab: "product",
    tab: "product",
    rightSidePane: false,
    isLoading: false,
    recordsTotal: 0,
  }),
  methods: {
    createNew: function () {
      this.createMode = true;
      this.rightSidePane = true;
      // this.productForm = false;
      // this.storesForm = false;
      // this.geographyForm = false;
      // this.salesForceForm = false;
      (this.product = {
        level_id: null,
        parent_id: null,
        name: null,
      }),
        (this.stores = {
          level_id: null,
          parent_id: null,
          name: null,
        }),
        (this.salesForce = {
          level_id: null,
          parent_id: null,
          name: null,
        }),
        (this.geography = {
          level_id: null,
          parent_id: null,
          name: null,
        }),
        (this.nielsen = {
          id: null,
          name: null,
        });
    },
    renderRightSide: function (event) {
      this.rightSidePane = true;
      if (this.tab === "product") {
        this.product = event;
      }
      if (this.tab === "stores") {
        this.stores = event;
      }
      if (this.tab === "sales-force") {
        this.salesForce = event;
      }
      if (this.tab === "geography") {
        this.geography = event;
      }
      if (this.tab === "nielsen") {
        this.nielsen = event;
      }
    },
    closeForm: function () {
      this.createMode = false;
      this.rightSidePane = false;
      this.product = {};
      this.stores = {};
      this.salesForce = {};
      this.geography = {};
      this.nielsen = {};
    },
    saveProduct: async function () {
      if (this.tab === "product" && !this.createMode) {
        const response = await BackendServices.updateProductHierarchyLevels(
          this.product
        );
        const changedElementIndex = this.tableData.findIndex(
          (e) => e.id === response.data.id
        );
        this.tableData[changedElementIndex].name = response.data.name;
        this.tableData[changedElementIndex].parent_id = response.data.parent_id;
        this.rightSidePane = false;
      } else if (this.tab === "product" && this.createMode) {
        BackendServices.createProductHierarchyLevel(this.product);
        BackendServices.getProductHierarchyLevels().then((response) => {
          this.tableData = response.data;
        });
        this.rightSidePane = false;
      } else if (this.tab === "stores" && !this.createMode) {
        const response = await BackendServices.updateStoreHierarchyLevels(
          this.stores
        );
        const changedElementIndex = this.tableData.findIndex(
          (e) => e.id === response.data.id
        );
        this.tableData[changedElementIndex].name = response.data.name;
        this.tableData[changedElementIndex].parent_id = response.data.parent_id;
        this.rightSidePane = false;
      } else if (this.tab === "stores" && this.createMode) {
        BackendServices.createStoreHierarchyLevel(this.stores);
        BackendServices.getStoreHierarchyLevels().then((response) => {
          this.tableData = response.data;
        });
        this.rightSidePane = false;
      } else if (this.tab === "geography" && !this.createMode) {
        const response = await BackendServices.updateGeographyHierarchyLevels(
          this.geography
        );
        const changedElementIndex = this.tableData.findIndex(
          (e) => e.id === response.data.id
        );
        this.tableData[changedElementIndex].name = response.data.name;
        this.tableData[changedElementIndex].parent_id = response.data.parent_id;
        this.rightSidePane = false;
      } else if (this.tab === "geography" && this.createMode) {
        BackendServices.createGeographyHierarchyLevel(this.geography);
        BackendServices.getGeographyHierarchyLevels().then((response) => {
          this.tableData = response.data;
        });
        this.rightSidePane = false;
      } else if (this.tab === "sales-force" && !this.createMode) {
        const response = await BackendServices.updateSalesforceHierarchyLevels(
          this.salesForce
        );
        const changedElementIndex = this.tableData.findIndex(
          (e) => e.id === response.data.id
        );
        this.tableData[changedElementIndex].name = response.data.name;
        this.tableData[changedElementIndex].parent_id = response.data.parent_id;
        this.rightSidePane = false;
      } else if (this.tab === "sales-force" && this.createMode) {
        BackendServices.createSalesforceHierarchyLevel(this.salesForce);
        BackendServices.getSalesforceHierarchyLevels().then((response) => {
          this.tableData = response.data;
        });
        this.rightSidePane = false;
      } else if (this.tab === "nielsen") {
        const response = await BackendServices.updateNielsenArea(this.nielsen);
        const changedElementIndex = this.tableData.findIndex(
          (e) => e.id === response.data.id
        );
        this.tableData[changedElementIndex].value = response.data.value;
        this.rightSidePane = false;
      }
      this.createMode = false;
    },
    removeProduct: async function (event) {
      if (this.tab === "geography") {
        try {
          await BackendServices.deleteGeographyHierarchyLevels(event);
          const changedElementIndex = this.tableData.findIndex(
            (e) => e.id === event.id
          );
          this.tableData.splice(changedElementIndex, 1);
        } catch (err) {
          if (err.response.status === 422) {
            //future use of error toast > this operation only fails when there's other entities referencing the selected element
          }
        }
        this.rightSidePane = false;
      }
    },
  },
  watch: {
    tableTab: {
      immediate: true,
      deep: true,
      handler: function () {
        this.rightSidePane = false;

        if (this.tableTab === "product") {
          BackendServices.getProductHierarchyLevels().then(
            (result) => (this.tableData = result.data)
          );
        }

        if (this.tableTab === "stores") {
          BackendServices.getStoreHierarchyLevels().then((result) => {
            this.tableData = result.data;
          });
        }

        if (this.tableTab === "sales-force") {
          BackendServices.getSalesforceHierarchyLevels().then((response) => {
            this.tableData = response.data;
          });
        }

        if (this.tableTab === "geography") {
          BackendServices.getGeographyHierarchyLevels().then((response) => {
            this.tableData = response.data;
          });
        }

        if (this.tableTab === "nielsen") {
          BackendServices.getNielsenAreas().then((response) => {
            this.tableData = response.data;
          });
        }
      },
    },
  },
};
